import { render } from "./lockscreen.vue?vue&type=template&id=a13f7c82&scoped=true"
import script from "./lockscreen.vue?vue&type=script&lang=js"
export * from "./lockscreen.vue?vue&type=script&lang=js"

import "./lockscreen.vue?vue&type=style&index=0&id=a13f7c82&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13f7c82"]])

export default __exports__